import React from 'react';
// import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';

import Login from './pages/login/Login';
import Dashboard from './pages/dashboard/Dashboard';
import SuperAdminDashboard from './pages/dashboard/SuperAdminDashboard';
import AdminDashboard from './pages/dashboard/AdminDashboard';
import CandidateDashboard from './pages/dashboard/CandidateDashboard';
import LandingPage from './pages/Landingpage';
import Header from './pages/header';
import './App.css';
import Election from './pages/Election';
import State from './pages/State';
import District from './pages/District';
import Division from './pages/Division';
import AddPrabhaag from './pages/AddPrabhaag';
import AddPosition from './pages/AddPosition';
import AddCategory from './pages/AddCategory';
import AddMember from './pages/AddMember';
import Candidate from './pages/Candidate';
import AddLocalMember from './pages/AddLocalMember';
import AddElectors from './pages/AddElectors';
import AddUsers from './pages/AddUsers';
import Meeting from './pages/Meeting';
import InterestedCandidatePage from './pages/InterestedCandidatePage';
import ViewCandidate from './pages/ViewCandidate';
function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <Router>
          <Header />
          <Routes>
            <Route path="/view-candidate/:id" element={<ViewCandidate />} />

            <Route path="/InterestedCandidatePage" element={<InterestedCandidatePage />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/superadmin-dashboard" element={<SuperAdminDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/candidate-dashboard" element={<CandidateDashboard />} />
            <Route path="/election" element={<Election />} />
            <Route path="/state" element={<State />} />
            <Route path="/district" element={<District />} />
            <Route path="/division" element={<Division />} />
            <Route path="/add-prabhaag" element={<AddPrabhaag />} />
            <Route path="/add-position" element={<AddPosition />} />
            <Route path="/add-category" element={<AddCategory />} />
            <Route path="/add-member" element={<AddMember />} />
            <Route path="/candidate" element={<Candidate />} />
            <Route path="/add-local-member" element={<AddLocalMember />} />
            <Route path="/add-electors" element={<AddElectors />} />
            <Route path="/users" element={<AddUsers />} />
            <Route path="/meetings" element={<Meeting />} />
          </Routes>
        </Router>
      </div>
    </Provider>
  );
}

export default App;